import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "feelgrid.leaf.icon",
  "use": "feelgrid.leaf.icon-usage",
  "viewBox": "0 0 23.95 32.704",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 23.95 32.704\" id=\"feelgrid.leaf.icon\"><path data-name=\"Path 1092\" d=\"M296.248,94.763a2.59,2.59,0,0,0,.355.592,14.767,14.767,0,0,0,2.843,2.132h.118a.414.414,0,0,0-.118-.237A28.424,28.424,0,0,1,309.989,70.48s-10.9,10.9-7.7,26.771c0,.237.118.592.118.829,3.08.355,6.752.118,9.24-2.606,4.62-5.212,2.961-8.292,2.251-14.333S318.044,65.5,318.044,65.5s-12.793,1.185-20.493,11.727a17.5,17.5,0,0,0-3.435,9,16.2,16.2,0,0,0,.948,6.278A20.591,20.591,0,0,1,296.248,94.763Z\" transform=\"translate(-294.094 -65.505)\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/feelgrid.leaf.icon.svg
// module id = 22xX
// module chunks = 13